// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"ya_e7g2","volumeControl":"ya_e7g2","on":"pb64Yio","off":"dPeKqtR"};